class ProductFeatured extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Listen for flavor picker initialization
        window.addEventListener('flavor-picker:initialized', () => {
            const activeElement = document.querySelector('[data-go-to-link].active');
            if (activeElement) {
                activeElement.click();
            } else {
                // console.log('No active element found to click.');
            }
        }, { once: true }); // Use once: true to ensure the listener is removed after firing
    }

    attachListeners() {
        // Keep this method for future event listener implementations
    }
}

customElements.define('product-featured', ProductFeatured);
